module.exports = __webpack_public_path__ + "img/character-8.cf1ee2a0.svg";